import { Satellite } from '@algolia/satellite'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './assets/css/index.css'
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom'

import App from './App'
import reportWebVitals from './components/reportWebVitals'
import { initLaunchDarkly } from './featureFlags'
import { initDatadogRum } from './utils/datadogRum'

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            ),
        }),
    ],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    tracesSampleRate: 1.0,
    release: import.meta.env.VITE_SENTRY_RELEASE,
})

initDatadogRum()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Initialize LaunchDarkly before first render so flags are seeded (from
// localStorage) with no value flash. When LaunchDarkly is disabled or init
// fails, initLaunchDarkly() resolves to null and we render without the provider
// — every flag then resolves to its code default.
async function bootstrap(): Promise<void> {
    const LDProvider = await initLaunchDarkly()
    const tree = (
        <React.StrictMode>
            <Satellite>
                <App />
            </Satellite>
        </React.StrictMode>
    )
    root.render(LDProvider ? <LDProvider>{tree}</LDProvider> : tree)
}

bootstrap()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
